var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
define('areas/iServe/viewmodels/index',["require", "exports", "common/viewmodelbase", "services/navigator", "models/portal"], function (require, exports, Common, Navigator, Portal) {
    "use strict";
    var iServeViewModel = (function (_super) {
        __extends(iServeViewModel, _super);
        function iServeViewModel() {
            _super.call(this);
            this.mobileApps = [];
            this.breadCrumb = new Portal.ModuleBreadCrumbItemHolder();
            this.title = "iServe";
            ko.track(this, ["mobileApps"]);
        }
        iServeViewModel.prototype.onActivated = function (context) {
            this._symbol = {
                config: "",
                fragment: "tools",
                params: null,
                queryParams: null,
                queryString: null
            };
            this._currentNode = Portal.Context.shell.findNodeFor(this._symbol);
            this.getiServeTiles();
            this.createiServeCrumb(context);
        };
        iServeViewModel.prototype.createiServeCrumb = function (context) {
            for (var i = 0; i < this.breadCrumb.items.length; i++) {
                if (this.breadCrumb.items[i].name === "i-Serve") {
                    this.breadCrumb.items.remove(this.breadCrumb.items[i]);
                }
            }
            var parameter = context.path.split('/');
            var calledFromTools = parameter[1] != null ? JSON.parse(parameter[1]) : null;
            // calledFromTools - flag to see where iServe is called from (false - called from Dashboard, true - called from Tools)
            if (this.breadCrumb.items.length === 0) {
                if (calledFromTools == true) {
                    var crumb = Portal.BreadCrumbItem.from("i-Serve");
                    this.breadCrumb.items.push(crumb);
                }
            }
        };
        iServeViewModel.prototype.iServeProductClick = function (node) {
            var calledFromTools = false;
            var params = [];
            // enter if statement only if iServeProduct is called from Tools > iServe
            if (this.breadCrumb.items.length === 1) {
                calledFromTools = true;
            }
            params.push(new Navigator.NavigationParameter("shopId", node.shopId));
            switch (node.name.toLowerCase()) {
                case "payescape":
                    Navigator.navigateTo("payescapeproduct", "index", "/payescapeproduct", JSON.stringify(calledFromTools), params);
                    break;
                case "twinfield":
                    Navigator.navigateTo("twinfieldproduct", "index", "/twinfieldproduct", JSON.stringify(calledFromTools), params);
                    break;
                case "basecone":
                    Navigator.navigateTo("baseconeproduct", "index", "/baseconeproduct", JSON.stringify(calledFromTools), params);
                    break;
                case "cch gdpr compliance":
                    Navigator.navigateTo("cchgdprcompliance", "index", "/cchgdprcompliance", JSON.stringify(calledFromTools), params);
                    break;
            }
        };
        iServeViewModel.prototype.getiServeTiles = function () {
            var _this = this;
            if (this._currentNode.children != null) {
                var items = Enumerable.From(this._currentNode.children)
                    .Where(function (n) { return n.groupId === _this.title; });
                this.mobileApps = items.ToArray();
            }
        };
        return iServeViewModel;
    }(Common.ViewModelBase));
    var instance = new iServeViewModel();
    return instance;
});

